var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navigation"},[_c('div',{ref:"navigation",staticClass:"navigation-tab"},_vm._l((_vm.tabList),function(item,i){return _c('router-link',{key:i,ref:"link",refInFor:true,class:{
        active: _vm.$route.name === item.pathname
      },attrs:{"to":{
        name: item.pathname,
        params : { ..._vm.localeParams, ...item.params },
        query: { ...item.query },
        hash: item.hash
      }},nativeOn:{"click":function($event){return _vm.onTabClick.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t(item.title))+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }